module.exports = __webpack_public_path__ + "static/undraw_envelope-c0da60f2818a6ee5bdf41c2781b57464.svg";